// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"Heatmap3D_btnWrapper__2NeUg","sizeIcon":"Heatmap3D_sizeIcon__1YrDI","unityComponent":"Heatmap3D_unityComponent__14HD4"};